import { truckApi } from "../truck.api";
import { GetTruckImplement, GetTruckImplements, SaveTruckImplement, SaveTruckImplementDelete } from "./truckImplements.types";

export const truckImplementsApi = truckApi.injectEndpoints({
  endpoints: (build) => ({
    getTruckImplements: build.query<GetTruckImplements["response"], GetTruckImplements["args"]>({
      query: () => "/implement-type"
    }),
    getTruckImplement: build.query<GetTruckImplement["response"], GetTruckImplement["args"]>({
      query: ({ id }) => `/implement-type/${id}`
    }),
    saveTruckImplement: build.mutation<SaveTruckImplement["response"], SaveTruckImplement["args"]>({
      query: (body) => ({
        url: "/implement-type/save",
        method: "POST",
        body
      })
    }),
    saveTruckImplementDelete: build.mutation<SaveTruckImplementDelete["response"], SaveTruckImplementDelete["args"]>({
      query: ({ id }) => ({
        url: `/implement-type/delete/${id}`,
        method: "DELETE"
      })
    })
  })
});

truckImplementsApi.enhanceEndpoints({
  addTagTypes: ["TruckImplement"],
  endpoints: {
    getTruckImplements: {
      providesTags: (result, error) => (result && !error ? result.map(({ id }) => ({ type: "TruckImplement", id })) : ["TruckImplement"])
    },
    getTruckImplement: {
      providesTags: (result, error, { id }) => [{ type: "TruckImplement", id }]
    },
    saveTruckImplement: {
      invalidatesTags: (result, error, { id }) => (id ? [{ type: "TruckImplement", id }] : ["TruckImplement"])
    },
    saveTruckImplementDelete: {
      invalidatesTags: (result, error, { id }) => [{ type: "TruckImplement", id }]
    }
  }
});
